import React from 'react';
import { Typography } from '@mui/material';

/**
 * ## SchedulesHeaderTitle component
 * Title component for the Schedules page header.
 *
 * @returns {JSX.Element} The rendered SchedulesHeaderTitle component
 */
const SchedulesHeaderTitle = React.memo(function SchedulesHeaderTitle() {
  return (
    <Typography
      sx={{
        fontFamily: 'Poppins',
        fontWeight: 600,
        fontSize: '34px',
        lineHeight: '1.235',
        color: '#092056',
        letterSpacing: 0,
        whiteSpace: 'nowrap',
      }}
    >
      Escalar Serviços
    </Typography>
  );
});

export default SchedulesHeaderTitle;


